import type { LucideProps } from 'lucide-react';

interface PriorityIconProps extends LucideProps {
  opacity1: number;
  opacity2: number;
  opacity3: number;
}

const PriorityIconBase = ({
  opacity1,
  opacity2,
  opacity3,
  size = 18,
  ...props
}: PriorityIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="2" y="12" width="3" height="4" fill="currentColor" opacity={opacity1} />
    <rect x="7" y="8" width="3" height="8" fill="currentColor" opacity={opacity2} />
    <rect x="12" y="4" width="3" height="12" fill="currentColor" opacity={opacity3} />
  </svg>
);

export const LowPriorityIcon = (props: LucideProps) => (
  <PriorityIconBase opacity1={1} opacity2={0.2} opacity3={0.2} {...props} />
);

export const MediumPriorityIcon = (props: LucideProps) => (
  <PriorityIconBase opacity1={1} opacity2={1} opacity3={0.2} {...props} />
);

export const HighPriorityIcon = (props: LucideProps) => (
  <PriorityIconBase opacity1={1} opacity2={1} opacity3={1} {...props} />
);
